export const tableHeight = 670;
export const maxHeightPopover = '75vh';
export const maxHeightPopoverContent = 'calc(75vh - 165px)';
